/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export const LOG_CONTROL_STATUS_EVENT: string = "LogControlStatus";
